export const MMKVStoreKeyMap = {
  appSettings: 'appSettings',
  moderatorAppSettings: 'moderatorAppSettings',
  userProfile: 'userProfile',
  resumableFeedStore: 'resumableFeeds',
  eventStore: 'eventStore',
  appInstancesStore: 'appInstancesStore',
};
